import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Existing project values are kept as fallbacks so this React admin can point at
// the same Firestore data immediately. Production deployments should use CRA REACT_APP_* env vars.
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyALBVt409-HAzt0fmZqdXe2t7WUkkrdexw',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'coldstorageapp-94250.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'coldstorageapp-94250',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'coldstorageapp-94250.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '205488549237',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:205488549237:web:0ca7f81d4f97794508373c',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-C4D7DCCB4Q'
};

export const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
